require("dotenv").config();

module.exports = {
  environment: process.env.REACT_APP_ENV,
  apiUrl: process.env.REACT_APP_API_URL,
  facebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID,
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  googleReCaptchaSitekey: process.env.REACT_APP_GOOGLE_RECAPTCHA_SITEKEY,
  stripeKey: process.env.REACT_APP_STRIPE_KEY,
  segmentKey: process.env.REACT_APP_SEGMENT_KEY,
  xApiKey: process.env.REACT_APP_X_API_KEY,
  algolia: {
      app_id: process.env.REACT_APP_ALGOLIA_APP_ID,
      search_api_key: process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY,
      indices: {
          categories: `${process.env.REACT_APP_ALGOLIA_INDEX_PREFIX}_categories`,
          coaches: `${process.env.REACT_APP_ALGOLIA_INDEX_PREFIX}_coaches`,
          collections: `${process.env.REACT_APP_ALGOLIA_INDEX_PREFIX}_collections`,
          extra_contents: `${process.env.REACT_APP_ALGOLIA_INDEX_PREFIX}_extra_contents`,
          memberships: `${process.env.REACT_APP_ALGOLIA_INDEX_PREFIX}_memberships`,
          prerolls: `${process.env.REACT_APP_ALGOLIA_INDEX_PREFIX}_prerolls`,
          video_recipes: `${process.env.REACT_APP_ALGOLIA_INDEX_PREFIX}_video_recipes`,
          users: `${process.env.REACT_APP_ALGOLIA_INDEX_PREFIX}_users`,
          videos: `${process.env.REACT_APP_ALGOLIA_INDEX_PREFIX}_videos`,
          teams: `${process.env.REACT_APP_ALGOLIA_INDEX_PREFIX}_teams`,
      }
  }
}